import React from 'react';
import './landing.css'; // Make sure this line is here
import Header from '../Header/header';
import { useNavigate } from 'react-router-dom';

const LandingPage = () => {
    const navigate = useNavigate(); 
  return (
    <div className="container">
        <Header />
     

      <main className="hero">
        <div className="hero-text">
          <h1>RENU VOTING <span>System</span></h1>
          <p>
            Your digital doorway to fast, secure, and user-friendly elections. <br />
            Your voice matters in recognizing the outstanding contributions of your colleagues.
            <br /> <br /> Trusted. Transparent. Tech-driven.
          </p>
          <button className="cta-btn" onClick={()=>navigate('/login')}>Get Started!</button>
        </div>

        <div className="hero-img">
       <img src="/vote.png" alt="Voting illustration" />


        </div>
      </main>
    </div>
  );
};

export default LandingPage;
